<template>
  <PublicLayout variant="no-bg" :hero="false" breadcrumbs-in-content>
    <UContainer>
      <div class="bg-white rounded-[16px] p-8 pb-10 mb-20 max-w-211.5">
        <h1
          class="text-size-h3 leading-9.5 tracking-[-0.004em] font-semibold text-content-default mb-6"
          style="font-family: Inter"
        >
          Политика использования файлов cookie
        </h1>
        <div class="flex flex-col gap-5">
          <p
            class="text-base leading-h1-paragraph text-neutral-default"
            style="font-family: Lato"
          >
            {{ intro }}
          </p>
          <div v-for="section in sections" :key="section.heading">
            <h2
              class="text-size-h5 leading-h1-paragraph font-bold text-content-default mb-3"
              style="font-family: Lato"
            >
              {{ section.heading }}
            </h2>
            <p
              class="text-base leading-h1-paragraph text-neutral-default whitespace-pre-line"
              style="font-family: Lato"
            >
              {{ section.content }}
            </p>
          </div>
        </div>
      </div>
    </UContainer>
  </PublicLayout>
</template>

<script setup lang="ts">
import PublicLayout from '~/layouts/PublicLayout.vue'

defineOptions({
  name: 'CookiePolicyPage',
})

definePageMeta({
  breadcrumbs: [
    { name: 'Документы', to: '/documents' },
    { name: 'Политика использования файлов cookie' },
  ],
})

useSeo({
  title: 'Политика использования cookie',
  description:
    'Политика использования файлов cookie на платформе «Код Спорта»: какие данные собираются и как ими управлять.',
  canonicalPath: '/documents/cookie',
  noindex: true,
})

const intro = `Продолжая использовать данный веб-сайт без изменения настроек браузера, вы выражаете согласие на использование cookie-файлов в соответствии с настоящей Политикой. Если вы не согласны с использованием файлов cookie, пожалуйста, измените настройки своего браузера или прекратите использование сайта.`

const sections = [
  {
    heading: '1. Что такое cookie',
    content: `Cookie - это небольшие текстовые файлы, которые сохраняются на вашем устройстве при посещении сайта. Они позволяют распознавать вас при повторных визитах, сохранять настройки и обеспечивать работу определённых функций сайта.
Типы cookie-файлов:
  - Сеансовые - удаляются после закрытия браузера;
  - Постоянные - хранятся на устройстве до установленного срока истечения;
  - Сторонние - устанавливаются внешними сервисами и платформами.
Мы не используем cookie для хранения персональных данных без вашего согласия.`,
  },
  {
    heading: '2. Цели использования файлов cookie',
    content: `Мы используем cookie-файлы и аналогичные технологии для следующих целей:
Обязательные (критически важные). Необходимы для корректной работы сайта:
  - Хранение содержимого корзины;
  - Поддержка сессии и авторизации;
  - Сохранение данных, введённых в формах, в течение одного сеанса.
Функциональные. Улучшают пользовательский опыт:
  - Запоминают выбранный язык, регион, другие настройки;
  - Хранят информацию об уже предложенных функциях (например, онлайн-чат).
Аналитические. Используются для сбора статистических данных и оптимизации сайта:
  - Google Analytics, Яндекс.Метрика, Appsflyer и др.;
  - Анализ пользовательских действий;
  - Подсчёт ошибок, улучшение производительности сайта и интерфейса.
Рекламные и ссылочные. Позволяют оценивать эффективность рекламных кампаний и переходов с внешних источников (например, с сайтов партнёров или баннеров).`,
  },
  {
    heading: '3. Сторонние cookie',
    content: `Некоторые cookie-файлы могут быть установлены сторонними сервисами (например, Google, Яндекс, VK, YouTube). Мы не управляем их использованием и не контролируем содержание таких cookie. Мы рекомендуем ознакомиться с политиками конфиденциальности этих сервисов для получения дополнительной информации.
Вы можете отказаться от использования сторонних cookie, изменив настройки в вашем браузере или воспользовавшись инструментами настройки на сайтах соответствующих сервисов.`,
  },
  {
    heading: '4. Управление cookie',
    content: `Вы можете настроить браузер для блокировки или удаления cookie-файлов. Обратите внимание, что отключение cookie может повлиять на корректную работу некоторых функций сайта.
Если вы используете несколько устройств (например, смартфон и компьютер), настройки необходимо изменять отдельно для каждого устройства и браузера.`,
  },
  {
    heading: '5. Веб-маяки и подобные технологии',
    content:
      'На сайте и в электронных рассылках мы можем использовать веб-маяки (однопиксельные изображения), которые позволяют отслеживать взаимодействие с контентом. Они работают совместно с cookie и могут быть отключены при деактивации cookie или при блокировке загрузки изображений в настройках почтовой программы или браузера.',
  },
  {
    heading: '6. Обновление политики',
    content:
      'Актуальная версия настоящей Политики использования файлов cookie размещена в сети Интернет по адресу: https://mysite.com/cookie. Мы оставляем за собой право вносить в неё изменения в любое время без предварительного уведомления. Обновлённая редакция вступает в силу с момента её публикации по указанному адресу.',
  },
]
</script>
